class Header {
  constructor() {
    this._init();
  }

  _init() {
    const button = document.querySelector('.header-primary__burger-button');
    const burger = document.querySelector('.header-primary__burger-icon');
    const menu = document.querySelector('.header-primary__menu');
    const overlay = document.getElementById('overlay');
    const close = document.getElementById('close');
    const body = document.body;

    button?.addEventListener('click', function () {
      if (burger?.classList.contains('header-primary__burger-icon--active')) {
        burger?.classList.remove('header-primary__burger-icon--active');
        menu?.classList.remove('header-primary__menu--active');
        menu?.classList.add('header-primary__menu--inactive');
        overlay?.classList.remove('active');
        //body.style.overflow = 'auto';
      } else {
        burger?.classList.add('header-primary__burger-icon--active');
        menu?.classList.add('header-primary__menu--active');
        menu?.classList.remove('header-primary__menu--inactive');
        overlay?.classList.add('active');
        //  body.style.overflow = 'hidden';
      }
    });

    overlay?.addEventListener('click', function () {
      burger?.classList.remove('header-primary__burger-icon--active');
      menu?.classList.remove('header-primary__menu--active');
      menu?.classList.add('header-primary__menu--inactive');
      overlay?.classList.remove('active');
      // body.style.overflow = 'auto';
    });

    close?.addEventListener('click', function () {
      burger?.classList.remove('header-primary__burger-icon--active');
      menu?.classList.remove('header-primary__menu--active');
      menu?.classList.add('header-primary__menu--inactive');
      overlay?.classList.remove('active');
      //  body.style.overflow = 'auto';
    });
  }
}

export const header = new Header();
